export const HOTEL_PAYMENT_STEP_SUBTITLE = (
  canRedeemRewards: boolean
) => {
  if (canRedeemRewards) {
    return "You can use rewards and the payment method you add to book this trip.";
  }
  return "Choose the payment method to book this trip.";
};

export const HOTEL_MOBILE_PAYMENT_STEP_SUBTITLE = (
  canRedeemRewards: boolean
) => {
  if (canRedeemRewards) {
    return "Pay for your booking using rewards, on a Capital One credit card, or use a combination of both.";
  }
  return "Pay for your booking using a Capital One credit card.";
};

export const HOTEL_PAYMENT_CARD_SUBTITLE_WITH_CREDITS_AND_OFFERS = (
  canRedeemRewards: boolean
) => {
  if (canRedeemRewards) {
    return "Combine travel offers, travel credits, rewards, and your Capital One credit card to book this trip.";
  }
  return "Choose the payment method to book this trip.";
};
